import React, { createContext, useContext, useState } from 'react';
import useInterval from '../utils/useInterval';

interface TimeTickerContextType {
  currentTime: number;
}

const TimeTickerContext = createContext<TimeTickerContextType>({ currentTime: Date.now() });

export const useTimeTicker = () => useContext(TimeTickerContext);

/**
 * Global time ticker that updates once per second.
 * All child components can subscribe to this single interval
 * instead of creating their own intervals.
 * 
 * This dramatically improves performance when rendering many time-sensitive components.
 */
export const TimeTickerProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [currentTime, setCurrentTime] = useState(Date.now());

  useInterval(() => {
    setCurrentTime(Date.now());
  }, 1000);

  return (
    <TimeTickerContext.Provider value={{ currentTime }}>
      {children}
    </TimeTickerContext.Provider>
  );
};
